import * as React from 'react';

import { Spinner, Colors } from '@origin-digital/style-guide';
import { Box } from '@origin-digital/layout';
import styled from 'styled-components';

interface LoaderProps {
  height: string;
}

const LoaderComponent: React.SFC<LoaderProps> = ({ height }) => (
  <Box
    justifyContent="center"
    alignItems="center"
    display="flex"
    height={height}
    data-id="loading-spinner"
  >
    <Spinner size={'lg'} />
  </Box>
);

const LoaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${Colors.WHITE};
`;

const Loader: React.SFC<LoaderProps> = ({ height }) => (
  <LoaderWrapper>
    <LoaderComponent height={height} />
  </LoaderWrapper>
);

export { Loader };
